export const drawerTableLayout = {
  en: [
    {
      width: 60,
      label: "",
      dataKey: "actions",
      type: "actions",
    },
    {
      width: 240,
      label: "Title",
      dataKey: "title",
    },
    {
      width: 120,
      label: "Tags",
      dataKey: "tags",
      type: "tags",
    },
  ],
  heb: [
    {
      width: 60,
      label: "",
      dataKey: "actions",
      type: "actions",
    },
    {
      width: 240,
      label: "כותרת",
      dataKey: "title",
    },
    {
      width: 120,
      label: "קטגוריות",
      dataKey: "tags",
      type: "tags",
    },
  ],
};
